/* Ebook-home enhancements only. Native Shopify forms work without this script. */
(() => {
  const body = document.body;
  if (!body.classList.contains('kore-guide-home')) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const ns = 'http://www.w3.org/2000/svg';
  let dispose = () => {};
  const makeSvg = (name, attrs) => {
    const node = document.createElementNS(ns, name);
    Object.entries(attrs).forEach(([key,value]) => node.setAttribute(key,String(value)));
    return node;
  };

  function mount() {
    dispose();
    const abort = new AbortController();
    const {signal} = abort;
    let frame = 0, scrollFrame = 0, last = 0, stopped = false;
    const cycles = [...document.querySelectorAll('.kg-cycle')].map(node => ({node,items:[...node.querySelectorAll('li')],radius:0,time:0,active:false,paused:false}));
    const ecos = [...document.querySelectorAll('.kg-ecosystem:has(.kg-home-ecosystem)')].map(node => ({node,items:['bladder','vagina','gut'].map(organ=>node.querySelector(`[data-organ="${organ}"]`)).filter(Boolean),time:0,current:-1,active:false}));
    const routes = [...document.querySelectorAll('.kg-protocol')].map(node => {
      const svg = node.querySelector('.kg-protocol-route');
      if(!svg)return null;
      const path = makeSvg('path',{'class':'kg-home-route-line'});
      const dot = makeSvg('circle',{'class':'kg-home-route-traveler',r:6});
      svg.replaceChildren(path,dot);
      return {node,svg,path,dot,items:[...node.querySelectorAll('.kg-step')],time:0,length:0,centers:[],active:false};
    }).filter(Boolean);
    const timelines = [...document.querySelectorAll('.kg-timeline')].map(node => ({node,items:[...node.children],height:0,start:14,stops:[]}));
    const states = [...cycles,...ecos,...routes];
    const byNode = new Map(states.map(state=>[state.node,state]));
    const cards = [...document.querySelectorAll('.kg-mirror-card')];
    cards.forEach((card,i) => card.style.setProperty('--kg-glow-delay',`${i%3*130}ms`));
    document.querySelectorAll('.kg-reasons-grid article').forEach(card => {
      card.style.setProperty('--kg-science-shadow',getComputedStyle(card).backgroundColor);
    });

    const timelineProgress = () => {
      scrollFrame=0;
      timelines.forEach(state => {
        const top = state.node.getBoundingClientRect().top + state.start;
        const progress = reduce.matches ? 1 : Math.max(0,Math.min(1,(innerHeight*.66-top)/Math.max(1,state.height)));
        const hue = 290-145*progress;
        const color = progress===1 ? '#00331b' : `hsl(${hue} ${38+progress*22}% ${55-progress*32}%)`;
        state.node.style.setProperty('--kg-timeline-progress',progress.toFixed(4));
        state.node.style.setProperty('--kg-timeline-color',color);
        state.items.forEach((item,i) => item.classList.toggle('is-reached',progress>=state.stops[i]));
      });
    };
    const onScroll = () => { if (!scrollFrame) scrollFrame=requestAnimationFrame(timelineProgress); };
    const positionCycle = state => {
      state.items.forEach((item,i) => {
        const angle = -Math.PI/2 + i/state.items.length*Math.PI*2 + state.time/48000*Math.PI*2;
        const x=Math.cos(angle)*state.radius, y=Math.sin(angle)*state.radius;
        item.style.transform=`translate(-50%,-50%) translate(${x.toFixed(2)}px,${y.toFixed(2)}px)`;
      });
    };
    function geometry() {
      cycles.forEach(state => {
        state.radius=state.node.clientWidth*.36;
        state.node.classList.add('kg-orbit-ready');
        positionCycle(state);
      });
      routes.forEach(state => {
        const rect=state.node.getBoundingClientRect();
        state.centers=state.items.map(item=>{
          const r=item.querySelector('.kg-step-symbol').getBoundingClientRect();
          return {x:r.left-rect.left+r.width/2,y:r.top-rect.top+r.height/2};
        });
        state.dot.style.display=state.centers.length>1?'':'none';
        if(state.centers.length<2){state.path.setAttribute('d','');state.length=0;return;}
        let d='';
        const mobile=innerWidth<900;
        state.centers.forEach((p,i)=>{
          if(!i){d=`M${p.x} ${p.y}`;return;}
          const prev=state.centers[i-1];
          if(mobile){const dy=(p.y-prev.y)*.45;d+=` C${prev.x+18} ${prev.y+dy} ${p.x-18} ${p.y-dy} ${p.x} ${p.y}`;}
          else {const dx=(p.x-prev.x)*.42;const wave=i%2?38:-38;d+=` C${prev.x+dx} ${prev.y+wave} ${p.x-dx} ${p.y+wave} ${p.x} ${p.y}`;}
        });
        state.svg.setAttribute('viewBox',`0 0 ${Math.max(1,rect.width)} ${Math.max(1,rect.height)}`);
        state.path.setAttribute('d',d);
        state.length=state.path.getTotalLength();
        state.node.classList.add('kg-route-ready');
        const point=state.path.getPointAtLength(0);state.dot.setAttribute('cx',point.x);state.dot.setAttribute('cy',point.y);
      });
      timelines.forEach(state=>{
        state.node.classList.add('kg-timeline-ready');
        const first=state.items[0], final=state.items.at(-1);
        if(!first)return;
        const parent=state.node.getBoundingClientRect();
        state.start=first.getBoundingClientRect().top-parent.top+14;
        state.height=final.getBoundingClientRect().top-first.getBoundingClientRect().top;
        state.stops=state.items.map(item=>(item.getBoundingClientRect().top-first.getBoundingClientRect().top)/Math.max(1,state.height));
        state.node.style.setProperty('--kg-track-start',`${state.start}px`);
        state.node.style.setProperty('--kg-track-height',`${state.height}px`);
      });
      timelineProgress();
    }
    function tick(now) {
      frame=0;
      if(stopped || document.hidden || reduce.matches)return;
      const dt=last?Math.min(64,now-last):0;last=now;
      cycles.forEach(state=>{if(state.active&&!state.paused){state.time+=dt;positionCycle(state);}});
      ecos.forEach(state=>{
        if(!state.active)return;
        state.time+=dt;
        const current=Math.floor(state.time/2000)%state.items.length;
        if(current!==state.current){state.current=current;state.items.forEach((item,i)=>item.classList.toggle('is-current',i===current));}
      });
      routes.forEach(state=>{
        if(!state.active || !state.length)return;
        state.time+=dt;
        const point=state.path.getPointAtLength((state.time%7200)/7200*state.length);
        state.dot.setAttribute('cx',point.x.toFixed(2));state.dot.setAttribute('cy',point.y.toFixed(2));
        state.items.forEach((item,i)=>item.classList.toggle('is-current',Math.hypot(point.x-state.centers[i].x,point.y-state.centers[i].y)<32));
      });
      if(states.some(state=>state.active))frame=requestAnimationFrame(tick);else last=0;
    }
    const start=()=>{if(!frame&&!reduce.matches&&!document.hidden){last=0;frame=requestAnimationFrame(tick);}};
    const observer=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        const active=entry.isIntersecting;
        entry.target.classList.toggle('is-inview',active);
        const state=byNode.get(entry.target);if(state)state.active=active;
      });
      if(states.some(state=>state.active))start();
    },{threshold:0,rootMargin:'-6% 0px -12% 0px'});
    [...states.map(s=>s.node),...cards,...document.querySelectorAll('.kg-hero-art')].forEach(node=>observer.observe(node));
    cycles.forEach(state=>{
      state.node.addEventListener('pointerenter',()=>state.paused=true,{signal});
      state.node.addEventListener('pointerleave',()=>state.paused=false,{signal});
      state.node.addEventListener('focusin',()=>state.paused=true,{signal});
      state.node.addEventListener('focusout',()=>state.paused=false,{signal});
    });
    const preference=()=>{
      body.classList.toggle('kg-motion-ready',!reduce.matches);
      if(reduce.matches){cancelAnimationFrame(frame);frame=0;cycles.forEach(state=>{state.time=0;positionCycle(state);});ecos.forEach(state=>state.items.forEach(item=>item.classList.remove('is-current')));routes.forEach(state=>state.items.forEach(item=>item.classList.remove('is-current')));}
      else start();
      timelineProgress();
    };
    reduce.addEventListener('change',preference,{signal});
    document.addEventListener('visibilitychange',()=>{body.classList.toggle('kg-motion-paused',document.hidden);if(document.hidden){cancelAnimationFrame(frame);frame=0;}else start();},{signal});
    window.addEventListener('scroll',onScroll,{passive:true,signal});
    const resize=new ResizeObserver(geometry);
    [...cycles,...routes,...timelines].forEach(state=>resize.observe(state.node));
    geometry();preference();
    document.fonts?.ready.then(()=>{if(!stopped)geometry();});
    dispose=()=>{stopped=true;abort.abort();observer.disconnect();resize.disconnect();cancelAnimationFrame(frame);cancelAnimationFrame(scrollFrame);};
  }
  mount();
  let reload=0;
  const remount=()=>{clearTimeout(reload);reload=setTimeout(mount,0);};
  document.addEventListener('shopify:section:load',remount);
  document.addEventListener('shopify:section:unload',remount);
  document.addEventListener('shopify:section:reorder',remount);
})();
